import React from 'react';
import Styles from './nu-index-pc.module.scss';

export default function Content({ explanation }: IContent) {
  return explanation && <div className={Styles.contentDes}>{explanation}</div>;
}

interface IContent {
  explanation: string;
}
